import React, { useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import uuidv4 from "uuid/v4";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import {
  batchUpdateDriversLiveStatuses,
  batchUpdateDriversLocations,
  setProjectStarted,
  updateStopFromWebsocket,
  updateEtasFromWebsocket
} from "../../store/actions/project";
import { DWA_WS_URL } from "../data/constants";
import { getCookie } from "../../utils/cookies";

export let client;

const deviceId = uuidv4();

const UPDATE_DRIVER_WEBSOCKET_DATA_INTERVAL = 60;
// Track D: debounce window for coalescing live ETA updates into one Redux dispatch.
const ETA_UPDATE_DEBOUNCE_MS = 2500;

function DriverMarkers({
  projectId,
  //  solution,
  publishedOnce,
  // driverLocations,
  // colorsObj,
  // currentDriver,
  updateStopFromWebsocket,
  vehicles,
  mapRef,
  plan,
  setBoundsToCoord,
  isProjectStarted,
  setProjectStarted
}) {
  // Refit map bounds on driver change
  /*
  useEffect(() => {
    if (currentDriver && driverLocations[currentDriver]) {
      mapRef.current && mapRef.current.leafletElement.closePopup();

      setTimeout(() => {
        setBoundsToCoord(
          driverLocations[currentDriver].lat,
          driverLocations[currentDriver].lng,
          0.0015
        );
      }, 250);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDriver, mapRef, setBoundsToCoord]);

  const getColor = id => (colorsObj[id] >= 0 ? colorsObj[id] : 0);

  const handleClick = id => {};

  const refs = [];
  Object.keys(driverLocations).forEach(routeId => refs.push(React.createRef()));

  // Open current driver's popup
  useEffect(() => {
    const routeIndex = Object.keys(driverLocations).indexOf(currentDriver);

    setTimeout(() => {
      refs[routeIndex] &&
        refs[routeIndex].current &&
        refs[routeIndex].current.leafletElement.openPopup();
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDriver]);*/

  // Connect to websocket
  // TO2DO: Maybe not the best place to keep websocket connection

  const { current: collectedDataFromWebsocket } = useRef({
    updatedRouteIds: [],
    locations: {},
    liveStatuses: {
      active: {},
      inactive: {}
    }
  });

  // Track D: coalesce eta_update bursts (several drivers reporting at once) into a single Redux
  // dispatch per debounce window, so the route list never re-renders on every socket message.
  const { current: etaBuffer } = useRef({ data: {}, timer: null });

  const isDriverLiveLocationVisible = useSelector(
    state => state.map.isDriverLiveLocationVisible
  );

  const dispatch = useDispatch();

  // Track D: clear any pending coalesced ETA flush on unmount.
  useEffect(() => {
    return () => {
      if (etaBuffer.timer) {
        clearTimeout(etaBuffer.timer);
        etaBuffer.timer = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const connect = () => {
    if (
      plan &&
      (plan.ft_realtime_driver_tracking || plan.ft_live_status_updates)
    ) {
      const token = getCookie("accessToken")
        ? getCookie("accessToken").slice(7)
        : "";
      client = new W3CWebSocket(
        `${DWA_WS_URL}?projectId=${projectId}&owner=client&deviceId=${deviceId}&token=${token}`
      );

      client.onopen = () => {
        console.log("WebSocket Client Connected");
      };

      client.onclose = event => {
        console.log("WebSocket Client Disconnected");

        if (publishedOnce && event.code !== 1005 && token) {
          console.log("Reconnecting to websocket...");

          setTimeout(connect, 1000);
        }
      };

      client.onmessage = message => {
        if (publishedOnce) {
          const dataFromWebSocket = JSON.parse(message.data);
          switch (dataFromWebSocket.type) {
            case "location":
              if (plan.ft_realtime_driver_tracking) {
                const { lat, lng, date, route_id, error } = dataFromWebSocket;
                // If there is error set current vehicle driver as inactive
                if (error) {
                  collectedDataFromWebsocket.liveStatuses.inactive[
                    `${route_id}`
                  ] = undefined;
                } else {
                  // If there is not any error set current vehicle driver location lat lng and set live status as active
                  collectedDataFromWebsocket.locations[`${route_id}`] = {
                    lat,
                    lng,
                    date
                  };
                  collectedDataFromWebsocket.liveStatuses.active[
                    `${route_id}`
                  ] = true;
                }
                /* For severy socket message update we don't want update all application for one message so we collected 
                all message datas in collectedDataFromWebsocket then after specified time we batch update all state only once . 
                Now we update after each 60 sec instead of update every 200~300ms */
                const isTimeToBatchUpdateWebsocketData =
                  Math.round(Date.now() / 1000) %
                    UPDATE_DRIVER_WEBSOCKET_DATA_INTERVAL ===
                  0;

                if (isTimeToBatchUpdateWebsocketData) {
                  if (isDriverLiveLocationVisible) {
                    dispatch(
                      batchUpdateDriversLiveStatuses(
                        collectedDataFromWebsocket.liveStatuses
                      )
                    );
                    dispatch(
                      batchUpdateDriversLocations(
                        collectedDataFromWebsocket.locations
                      )
                    );
                  } else {
                    dispatch(
                      batchUpdateDriversLiveStatuses(
                        collectedDataFromWebsocket.liveStatuses
                      )
                    );
                  }
                }
              }
              break;
            case "service_change":
              if (plan.ft_live_status_updates)
                if (!isProjectStarted) setProjectStarted(true);
              updateStopFromWebsocket(dataFromWebSocket);
              break;
            case "eta_update":
              // Track D: live-recomputed ETAs relayed from the driver app (no service change).
              // Merge into the buffer and flush once on a short debounce (see etaBuffer).
              if (plan.ft_live_status_updates) {
                const { ETAs } = dataFromWebSocket;
                if (ETAs && Object.keys(ETAs).length) {
                  Object.keys(ETAs).forEach(rid => {
                    etaBuffer.data[rid] = {
                      ...(etaBuffer.data[rid] || {}),
                      ...ETAs[rid]
                    };
                  });
                  if (!etaBuffer.timer) {
                    etaBuffer.timer = setTimeout(() => {
                      const batched = etaBuffer.data;
                      etaBuffer.data = {};
                      etaBuffer.timer = null;
                      dispatch(updateEtasFromWebsocket({ ETAs: batched }));
                    }, ETA_UPDATE_DEBOUNCE_MS);
                  }
                }
              }
              break;
            default:
              return;
          }
        }
      };

      return client;
    }
  };

  useEffect(() => {
    if (!projectId) {
      return;
    }
    if (client && client.readyState <= 1) {
      client.close();
    }
    connect();

    return () => client && client.readyState <= 1 && client.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return <></>;

  /*
  const getRoute = id => solution.routes.find(el => el.id === id);

  const getRouteTimeWindows = id => {
    let routeGroup = null;
    Object.keys(solution.routeGroups).forEach(key => {
      solution.routeGroups[key].forEach(backhaulGroup => {
        backhaulGroup.forEach(route => {
          if (route.id === id) {
            routeGroup = route;
          }
        });
      });
    });

    const allStartEndStops = routeGroup.stops.filter(
      stop => stop.type === "start" || stop.type === "end"
    );

    const start =
      allStartEndStops[0]?.finish_time || allStartEndStops[0]?.end_time;
    const end = allStartEndStops[allStartEndStops.length - 1]?.arr_time;

    return [start, end];
  };

  const getVehicleName = id => {
    const vehicle = vehicles.find(vehicle => vehicle?.vehicle_id === id);

    return vehicle ? vehicle?.type_id?.name : "";
  };

  const getTimeWindows = routeId => {
    const timeWindows = getRouteTimeWindows(routeId);

    return timeWindows
      ? `${secondsToTime(timeWindows[0])} - ${secondsToTime(timeWindows[1])}`
      : "";
  };


  return Object.keys(driverLocations)
    .filter(
      routeId => driverLocations[routeId].lat && driverLocations[routeId].lng
    )
    .map((routeId, index) => (
      <Marker
        key={routeId}
        ref={refs[index]}
        onClick={() => handleClick(routeId)}
        position={[driverLocations[routeId].lat, driverLocations[routeId].lng]}
        zIndexOffset={50070}
        icon={window.L.divIcon({
          iconSize: [40, 47],
          iconAnchor: [20, 45],
          html: `<div class="marker-box">
                     <img style="pointer-events: none;" src="data:image/svg+xml;base64,${btoa(
                       createDriverMarker(
                         routeColors[getColor(routeId) % routeColors.length]
                       )
                     )}" />
                  </div>`
        })}
      >
        <Popup>
          <Box>
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              {getRoute(routeId) &&
                getVehicleName(getRoute(routeId).vehicle_id)}
            </Typography>

            {getRoute(routeId) && (
              <Typography variant="body2">{getTimeWindows(routeId)}</Typography>
            )}

            {driverLocations[routeId] && (
              <Typography
                variant="body2"
                color="secondary"
                style={{ fontStyle: "italic", fontSize: remCalc(12) }}
              >
                Seen at {parseDateStr(driverLocations[routeId].date)}
              </Typography>
            )}
          </Box>
        </Popup>
      </Marker>
    ));*/
}

const mapStateToProps = state => ({
  projectId: state.project.id,
  publishedOnce: state.project.published_once,
  currentDriver: state.map.currentDriver,
  vehicles: state.project.vehicles,
  plan:
    (state.auth.userData.organisationSite &&
      state.auth.userData.organisationSite.organisation.plan) ||
    {},
  isProjectStarted: state.project.project_started
});

export default connect(mapStateToProps, {
  updateStopFromWebsocket,
  setProjectStarted
})(DriverMarkers);
